<template>
  <div class="flex flex-col">
    <h2>Razas</h2>

    <router-link
      v-if="hasPermission('edit_breeds')"
      :to="{ name: 'breedsForm' }"
      class="primary-button mx-0 mt-2"
      >Crear Raza</router-link
    >

    <div v-if="!loading">
      <div v-if="dogs" class="card mt-6">
        <h2>Perros</h2>
        <table class="table-auto text-sm mt-4 bg-white">
          <thead class="text-left">
            <tr class="bg-primary-100">
              <th class="px-4 py-3 rounded text-xs font-semibold text-primary-700 uppercase tracking-wide">Razas</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="dog in dogs" :key="dog.id" class="table-row">
              <td class="table-cell">
                {{ dog.name }}
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="dogsTotalPages > 1" class="mt-6 mx-auto">
          <button
            v-for="page in dogsTotalPages"
            :key="page"
            class="button-interactive mx-4"
            :class="[
              { 'font-bold': page === dogsCurrentPage },
              { 'font-light': page !== dogsCurrentPage },
            ]"
            @click.prevent="
              dogsCurrentPage = page;
              loadDogs();
            "
          >
            {{ page }}
          </button>
        </div>
      </div>

      <div v-if="cats" class="card mt-6">
        <h2>Gatos</h2>
        <table class="table-auto text-sm mt-4 bg-white">
          <thead class="text-left">
            <tr class="bg-primary-100">
              <th class="px-4 py-3 rounded text-xs font-semibold text-primary-700 uppercase tracking-wide">Razas</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="cat in cats" :key="cat.id" class="table-row">
              <td class="table-cell">
                {{ cat.name }}
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="catsTotalPages > 1" class="mt-6 mx-auto">
          <button
            v-for="page in catsTotalPages"
            :key="page"
            class="button-interactive mx-4"
            :class="[
              { 'font-bold': page === catsCurrentPage },
              { 'font-light': page !== catsCurrentPage },
            ]"
            @click.prevent="
              catsCurrentPage = page;
              loadCats();
            "
          >
            {{ page }}
          </button>
        </div>
      </div>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Breeds",

  data() {
    return {
      dogs: null,
      dogsCurrentPage: 1,
      dogsTotalPages: 0,
      cats: null,
      catsCurrentPage: 1,
      catsTotalPages: 0,
      loading: false,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "breeds");

    this.loadDogs();
    this.loadCats();
  },

  methods: {
    formatDatetime,

    integerToCurrency,

    async loadDogs() {
      this.loading = true;

      try {
        const response = await api.breeds.getDogs([
          {
            name: "page",
            value: this.dogsCurrentPage,
          },
        ]);
        this.dogs = response.data;
        this.dogsCurrentPage = response.current_page;
        this.dogsTotalPages = response.last_page;
      } catch (error) {
        console.log(error);
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    async loadCats() {
      this.loading = true;

      try {
        const response = await api.breeds.getCats([
          {
            name: "page",
            value: this.catsCurrentPage,
          },
        ]);
        this.cats = response.data;
        this.catsCurrentPage = response.current_page;
        this.catsTotalPages = response.last_page;
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },
  },
};
</script>